import {
    GET_LIVE_BOOKINGS_REQUEST,
    GET_LIVE_BOOKINGS_SUCCESS,
    GET_LIVE_BOOKINGS_FAILURE,
    REASSIGN_TRIP_REQUEST,
    REASSIGN_TRIP_SUCCESS,
    REASSIGN_TRIP_FAILURE,
    REASSIGN_TRIP_RESET,
    AUTO_COMPLETE_REQUEST,
    AUTO_COMPLETE_SUCCESS,
    AUTO_COMPLETE_FAILURE,
    AUTO_COMPLETE_RESET,
} from "../actions/liveAction";

interface LiveState {
    loading: boolean;
    liveBookings: any[];
    tableLength: number;
    error: string | null;
    reassignTripLoading: boolean;
    reassignTripMessage: string | null;
    reassignTripError: string | null;
    autoCompleteLoading: boolean;
    autoCompleteSuccess: boolean;
    autoCompleteData: any;
    autoCompleteError: any;
}
const initialState: LiveState = {
    loading: false,
    liveBookings: [],
    tableLength: 0,
    error: null,
    reassignTripLoading: false,
    reassignTripMessage: null,
    reassignTripError: null,
    autoCompleteLoading: false,
    autoCompleteSuccess: false,
    autoCompleteData: null,
    autoCompleteError: null,
};

const liveReducer = (
    state = initialState,
    action: any
): LiveState => {
    switch (action.type) {
        case GET_LIVE_BOOKINGS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case GET_LIVE_BOOKINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                liveBookings: action.payload.data,
                tableLength: action.payload.tablelength,
            };

        case GET_LIVE_BOOKINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };


        case REASSIGN_TRIP_REQUEST:
            return {
                ...state,
                reassignTripLoading: true,
                reassignTripMessage: null,
                reassignTripError: null,
            };

        case REASSIGN_TRIP_SUCCESS:
            return {
                ...state,
                reassignTripLoading: false,
                reassignTripMessage: action.payload.message,
            };

        case REASSIGN_TRIP_FAILURE:
            return {
                ...state,
                reassignTripLoading: false,
                reassignTripError: action.payload,
            };

        case REASSIGN_TRIP_RESET:
            return {
                ...state,
                reassignTripLoading: false,
                reassignTripMessage: null,
                reassignTripError: null,
            };

        case AUTO_COMPLETE_REQUEST:
            return {
                ...state,
                autoCompleteLoading: true,
                autoCompleteSuccess: false,
                autoCompleteError: null,
            };

        case AUTO_COMPLETE_SUCCESS:
            return {
                ...state,
                autoCompleteLoading: false,
                autoCompleteSuccess: true,
                autoCompleteData: action.payload,
            };

        case AUTO_COMPLETE_FAILURE:
            return {
                ...state,
                autoCompleteLoading: false,
                autoCompleteSuccess: false,
                autoCompleteError: action.payload,
            };

        case AUTO_COMPLETE_RESET:
            return {
                ...state,
                autoCompleteLoading: false,
                autoCompleteSuccess: false,
                autoCompleteData: null,
                autoCompleteError: null,
            };


        default:
            return state;
    }
};

export default liveReducer;